/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskWidgetSettingsType from '@jira/spa-apps__project-settings-service-desk-widget-settings/src/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type {
	Location,
	Query,
	Route,
	Match,
	HistoryAction,
} from '@atlassian/react-resource-router';

export const LazyProjectSettingsServiceDeskWidgetSettings: LazyComponent<{
	(props: {
		location: Location;
		query: Query;
		route: Route;
		match: Match;
		action: HistoryAction;
	}): React.JSX.Element;
	displayName: string;
}> = lazyForPaint<typeof ProjectSettingsServiceDeskWidgetSettingsType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-widget-settings", jiraSpaEntry: "async-project-settings-service-desk-widget-settings" */ '@jira/spa-apps__project-settings-service-desk-widget-settings/src/index.tsx'
		),
);

const AsyncProjectSettingsServiceDeskWidgetSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskWidgetSettings}
		pageId="project-settings-widget-settings"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskWidgetSettings;
